import { z } from "zod";

export enum OtpScene {
  VerifyMail = "verifyMail",
  ResetPasswordVerifyMail = "resetPasswordVerifyMail",
}

export const otpRequestSchema = z.object({
  scene: z.nativeEnum(OtpScene),
  context: z.record(z.any()).optional(),
});

export type OtpRequestInput = z.infer<typeof otpRequestSchema>;

export const otpValidateSchema = z.object({
  otp: z.string(),
  params: otpRequestSchema,
});

export type OtpValidateInput = z.infer<typeof otpValidateSchema>;
